<div class="current-slip-core-desktop" [ngClass]="{ 'top-winner-slip-mobile': isMobileView }">
  <div class="container">
    <div class="bet-slip-header top-winner border header">
      <div class="header-text blackText">{{ 'top_winner' | translate }}</div>
    </div>
    <div class="bet-slip-container top-winner">
      <ng-container *ngIf="this._DataHelper.topWinnerDataActiveTab !== 0">
        <div class="bet-slip-tab-row sub-header">
          <ng-container *ngFor="let tab of tabs">
            <ng-container *ngIf="getTopWinnerData(tab.timeType).length > 0">
              <div class="tab-item tab-height-100" (click)="onTabClick(tab.timeType)" [ngClass]="{ active: this._DataHelper.topWinnerDataActiveTab === tab.timeType }">
                {{ tab.title | translate }}
              </div>
            </ng-container>
          </ng-container>
        </div>
        <div class="bet-slip-tab-row separate-line">
          <div class="tab-item fs-12">{{ 'Slip_Gain' | translate }}</div>
          <div class="tab-item fs-12">{{ 'Stake' | translate }}</div>
        </div>
        <div *ngFor="let item of getTopWinnerData(this._DataHelper.topWinnerDataActiveTab); let i = index" [attr.data-index]="i">
          <div class="bet-slip-tab-row top-winner-row" (click)="handleOpen(i)">
            <div class="result-line">
              <span>{{ i + 1 }}.</span>
              <span>{{ item.SlipWinResult.WinAmount | balanceFormat }}</span>
            </div>
            <div class="result-line">
              <span class="right-side">{{ item.SlipWinResult.Amount | balanceFormat }}</span>
              <div class="collapsable">
                <span [ngClass]="item?.isOpen ? '' : 'active'" class="icon"> <image-loader-utils url="collapse"></image-loader-utils></span>
              </div>
            </div>
          </div>
          <div [@openClose]="item.isOpen ? 'open' : 'closed'" class="collapsable-content" [ngStyle]="{ 'height.px': (item.SlipDetails.length + 1) * 46 }">
            <div *ngFor="let slip of item.SlipDetails">
              <div class="slip-content-block">
                <div class="slip-content-row">
                  <span>{{ slip.OddsType }} {{ slip.SpecialBetValue }} - ({{ slip.Outcomes }} )</span>
                  <span class="odd">{{ slip.OddValue }}</span>
                </div>
                <div class="slip-content-row event-name">
                  <span>{{ slip.EventName }}</span>
                </div>
              </div>
            </div>
            <div class="slip-content-block">
              <div class="slip-content-row">
                <span>{{ item.SlipDetails.length }}{{ 'x_combin' | translate }}</span>
                <span class="total-value">{{ 'OddRate' | translate }} {{ item.totalOdd | number : '1.2-2' }}</span>
              </div>
            </div>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="this._DataHelper.topWinnerDataActiveTab === 0">
        <div class="bet-slip-tab-row sub-header no-data">{{ 'top_winner_no_data' | translate }}</div>
      </ng-container>
    </div>
  </div>
</div>
